import React from "react"
import PropTypes from "prop-types";
import Link from "../../Link";
import {
    APMIcon,
    ContainerIcon,
    LLMObservabilityIcon,
    InfraMonitoring, LLMIcon,
    LogsIcon, MetricsIcon,
    RUMIcon,
    SyntheticIcon,
    OpsAIcon
} from "../icons-header";
import { useTranslation } from "next-i18next";
import Image from "next/image";


const ProductDropdown = (props) => {
    const { t } = useTranslation("header");
    let dropdownItems = [
        {
            item1: [
                {
                    title: `${t('productsName.infrastructureMonitoring')}`,
                    link: '/product/infrastructure-monitoring/',
                    subtitle: 'Monitor servers, cloud & infra health',
                    icon: <InfraMonitoring />,
                },
                {
                    title: `${t('productsName.APM')}`,
                    link: '/product/apm/',
                    subtitle: 'Track app performance & fix slowdowns',
                    icon: <APMIcon />,
                },
                {
                    title: `${t('productsName.logMonitoring')}`,
                    link: '/product/log-monitoring/',
                    subtitle: 'Debug faster with AI log insights',
                    icon: <LogsIcon />,
                },
                {
                    title: `${t('productsName.realUserMonitoring')}`,
                    link: '/product/real-user-monitoring/',
                    subtitle: 'Track UX, errors & performance',
                    icon: <RUMIcon />,
                }

            ]
        },
    ]
    let dropdownItems1 = [
        {
            item2: [
                {
                    title: `${t('productsName.opsAI')}`,
                    link: '/product/ops-ai/',
                    subtitle: 'Detect, debug & auto-fix issues',
                    icon: <OpsAIcon />
                },
                {
                    title: `${t('productsName.syntheticMonitoring')}`,
                    link: '/product/synthetic-monitoring/',
                    subtitle: 'Test APIs & prevent outages',
                    icon: <SyntheticIcon />,
                },
                {
                    title: `${t('productsName.browserTesting')}`,
                    link: '/product/browser-testing/',
                    subtitle: 'Test web apps across browsers & devices',
                    icon: <MetricsIcon />
                },
                {
                    title: `${t('productsName.llmMonitoring')}`,
                    link: '/product/llm-observability/',
                    subtitle: 'Monitor and evaluate LLM apps',
                    icon: <LLMObservabilityIcon />
                },
                // {
                //     title: `${t('productsName.llmMonitoring')}`,
                //     link: '/product/llm-observability/',
                //     subtitle: '',
                //     icon: <LLMIcon />
                // }

            ]
        },
    ]
    // let dropdownItems2 = [
    return <>
        <div className={'inner-wrapper product-menu'}>
            <div className={'d-flex sub-menu'}>
                <div className={'menus'}>
                    <div className="product-heading-title">
                        Products
                    </div>
                    <div className={'d-flex'}>
                        {dropdownItems.map((mw_item, index) => {
                            return mw_item.item1 && Array.isArray(mw_item.item1) &&
                                <div className={'product-links'} key={index}>
                                    <div className={'product-drop'}>
                                        {mw_item.item1 && mw_item.item1.map((__item, __index) => {
                                            return <div key={__index}>
                                                {__item.link &&
                                                    <Link href={__item.link} aria-label={'Middleware Dropdown'}
                                                        passHref>
                                                        <div className={'dropdown-menu'} onClick={props.onLinkClick}>
                                                            <div className={'header-heading'}>
                                                                <span>{__item.icon}</span>
                                                                <div className="header-flex">
                                                                    
                                                                    {__item.title}
                                                                    {__item.isNew && <img src={"/images/product/new_features_dark.svg"} alt={"New Feature"} width={100} height={100} className={"new_features"} />}
                                                                    <p className={'small-text'}>{__item.subtitle}</p>
                                                                </div>
                                                                
                                                            </div>

                                                        </div>
                                                    </Link>
                                                }
                                            </div>
                                        })}
                                    </div>
                                </div>


                        })}
                        {dropdownItems1.map((item1, index) => {
                            return item1.item2 && Array.isArray(item1.item2) &&
                                <div className={'product-links'} key={index}>
                                    <div className={'product-drop'}>
                                        {item1.item2 && item1.item2.map((__item, __index) => {
                                            return <div key={__index}>
                                                {__item.link &&
                                                    <Link href={__item.link} aria-label={'Middleware Dropdown'}
                                                        passHref>
                                                        <div className={'dropdown-menu'} onClick={props.onLinkClick}>
                                                            <div className={'header-heading'}>
                                                                <span>{__item.icon}</span>
                                                                <div className="header-flex">
                                                                    
                                                                    {__item.title}
                                                                    {__item.isNew && <img src={"/images/product/new_features_dark.svg"} alt={"New Feature"} width={100} height={100} className={"new_features"} />}
                                                                    <p className={'small-text'}>{__item.subtitle}</p>
                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </Link>}
                                            </div>
                                        })}
                                    </div>
                                </div>
                        })
                        }
                    </div>
                </div>
                <div className={"menu-cta"}>
                    <Image src={"/images/sub-menu-cta.webp"} alt={"Product Tour"} width={360} height={200} />
                    <div className="menu-cta-heading">{t('productHeaderQuate.title')}</div>
                    <p>{t('productHeaderQuate.description')}</p>
                    <Link href={"/product/"} passHref>Explore Products</Link>
                </div>
            </div>
        </div>
    </>
}
ProductDropdown.propTypes = {
    pageID: PropTypes.number,
    onLinkClick: PropTypes.any
}
export default ProductDropdown